<template>
  <div>
    <!-- Directive -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("DIRECTIVE") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-textarea
          :spellcheck="false"
          dense
          outlined
          rows="2"
          v-model="formGeneral.leadSentence"
          :error-messages="leadSentenceErrors"
          @input="$v.formGeneral.leadSentence.$touch()"
          @blur="$v.formGeneral.leadSentence.$touch()"
        />
      </v-col>
    </v-row>
    <!-- Void data -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("VOID_DATA") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-row class="ma-0">
          <v-col class="pa-0 pt-1">
            <v-icon class="ml-2 mt-2" v-if="!formGeneral.audio" tag="p"
              >fas fa-volume-off</v-icon
            >
            <audio
              class="ml-3"
              id="Audio"
              controls
              v-if="formGeneral.audio && formGeneral.audio.fileUrl"
              :key="keyAudio"
            >
              <source :src="formGeneral.audio.fileUrl" type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
            <div
              v-if="
                audioError && (!formGeneral.audio || !formGeneral.audio.fileUrl)
              "
            >
              <div class="v-messages theme--light error--text" role="alert">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">
                    音声データを選択ください。
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col class="d-flex pa-0">
            <v-spacer />
            <base-upload type="audio" v-model="formGeneral.audio">
              <span slot="activator">
                <v-btn class="primary" height="40px">{{
                  $t("FILE_SELECT")
                }}</v-btn>
              </span>
            </base-upload>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Script or void data  -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          台本
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-textarea
          :spellcheck="false"
          dense
          outlined
          rows="2"
          v-model="formGeneral.script"
          :error-messages="scriptErrors"
          @input="$v.formGeneral.script.$touch()"
          @blur="$v.formGeneral.script.$touch()"
        />
      </v-col>
    </v-row>
    <!-- Answer -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable"></v-col>
      <v-col>
        <v-row>
          <v-col
            class="pa-0"
            cols="6"
            v-for="(item, index) in $v.formGeneral.answers.$each.$iter"
            :key="item.id"
          >
            <v-radio-group
              hide-details
              class="mt-5"
              v-model="formGeneral.isAnsewr"
              :mandatory="false"
            >
              <v-text-field
                v-model="item.value.$model"
                :error-messages="answersErrors(item.value)"
                @input="item.value.$touch()"
                :success="item.$model.id == formGeneral.isAnsewr"
                @blur="item.value.$touch()"
                :style="
                  index % 2 == 0 ? 'margin-right:2.4rem' : 'margin-left:2.2rem'
                "
                dense
                outlined
              >
                <template v-slot:prepend>
                  <v-radio :value="item.$model.id"></v-radio>
                </template>
                <template v-slot:label>
                  <h3>
                    {{ item.$model.name }}
                    <span class="red--text">*</span>
                  </h3>
                </template>
              </v-text-field>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "FormShortSentences",
  mixins: [validationMixin],
  props: ["parent"],
  store: ["formGeneral"],
  validations: {
    formGeneral: {
      answers: {
        required,
        $each: {
          value: {
            required,
            strongAnswers(answers) {
              return !this.format.test(answers); // checks for special char
            },
          },
        },
      },
      leadSentence: { required },
      script: { required },
    },
  },
  mounted() {
    let update = this.$route.name.search("Update");
    if (update == -1) {
      this.formGeneral.leadSentence =
        "この問題では、はじめに みじかい文を きいてください。\nそれから こたえを きいて いちばん いいものを ひとつ えらんでください。";
    }
  },
  computed: {
    leadSentenceErrors() {
      const errors = [];
      if (!this.$v.formGeneral.leadSentence.$dirty) return errors;
      !this.$v.formGeneral.leadSentence.required &&
        errors.push("指示文を入力してください。");
      return errors;
    },
    scriptErrors() {
      const errors = [];
      if (!this.$v.formGeneral.script.$dirty) return errors;
      !this.$v.formGeneral.script.required &&
        errors.push("台本を入力してください。");
      return errors;
    },
  },
  data() {
    return {
      keyAudio: 0,
      audioError: false,
      format: /[^\u00BF-\u1FFF\u2C00-\uD7FF０-９Ａ-Ｚａ-ｚ_＿/／\s\w]/g,
    };
  },
  watch: {
    "formGeneral.audio": function () {
      this.keyAudio++;
    },
  },
  methods: {
    async getParams() {
      const {
        leadSentence,
        isAnsewr,
        answers,
        audio,
        script,
      } = this.formGeneral;
      this.audioError = !audio || !audio.fileUrl ? true : false;
      this.$v.$touch();
      var params = "";
      if (!this.$v.$anyError && !this.audioError) {
        params = {
          sub_key: this.$route.params[this.parent],
          parent: this.parent,
          name: [],
          answer1: answers[0].value,
          answer2: answers[1].value,
          answer3: answers[2].value,
          answer4: answers[3].value,
          script,
          lead_sentence: leadSentence,
          audio,
          image: "",
          verb: "",
          answer_correct: [isAnsewr],
          sub_question: {
            question1: {
              answers: [
                {
                  id: 1,
                  name: "回答1",
                  value: "",
                },
                {
                  id: 2,
                  name: "回答2",
                  value: "",
                },
                {
                  id: 3,
                  name: "回答3",
                  value: "",
                },
                {
                  id: 4,
                  name: "回答4",
                  value: "",
                },
              ],
              audio: null,
              isAnsewr: 1,
              script: "",
            },
            question2: {
              answers: [
                {
                  id: 1,
                  name: "回答1",
                  value: "",
                },
                {
                  id: 2,
                  name: "回答2",
                  value: "",
                },
                {
                  id: 3,
                  name: "回答3",
                  value: "",
                },
                {
                  id: 4,
                  name: "回答4",
                  value: "",
                },
              ],
              audio: null,
              isAnsewr: 1,
              script: "",
            },
          },
          list_answer: {
            sentence_answer: [],
            answer: [],
          },
        };
      }
      return params;
    },
    answersErrors(value) {
      if (value.$dirty && !value.required) return "回答を入力してください。";
      if (value.$dirty && !value.strongAnswers) {
        return "特殊文字以外を入力してください。";
      }
    },
  },
};
</script>
<style scoped>
#Audio {
  height: 40px;
  margin-top: 4px;
}
</style>